import { useNavigate } from "react-router-dom";
import PageLayout from "./PageLayout ";
import "./advocacy.css";
export default function Advocacy() {
  const navigate = useNavigate();
  return (
    <PageLayout
      title="Advocate for Sanatana Rights"
      desc="Promoting legal awareness, protecting cultural identity, and ensuring justice through advocacy."
    >
      <div className="advocacy-content">
        <p>
          The preservation and protection of Sanatana Dharma and its values
          require continuous legal awareness, active participation, and a
          collective commitment to justice. In the modern era, where legal,
          social, and cultural challenges are rapidly evolving, advocacy plays a
          crucial role in safeguarding the rights and identity of individuals
          and communities rooted in Sanatana traditions.
        </p>

        <p>
          At ICSAJ (International Council of Sanatan Advocacy & Justice), we are
          committed to building a strong legal framework that empowers
          individuals to stand for their rights peacefully and lawfully. Our
          advocacy initiatives aim to spread awareness about constitutional
          rights, promote lawful representation, and encourage responsible civic
          participation.
        </p>

        <p>
          Advocacy is not limited to legal professionals alone. Every citizen
          has the ability to contribute towards creating a just and aware
          society. By understanding the law, raising awareness, and supporting
          ethical practices, individuals can play a vital role in strengthening
          the foundation of justice.
        </p>

        <h4 className="mt-4">Our Key Focus Areas</h4>

        <ul className="advocacy-list">
          <li>Legal awareness campaigns and educational initiatives</li>
          <li>Protection of constitutional and cultural rights</li>
          <li>Public interest advocacy and representation</li>
          <li>Workshops, seminars, and legal training programs</li>
          <li>Collaboration with legal experts and researchers</li>
        </ul>

        <p>
          Through structured programs and initiatives, ICSAJ aims to bridge the
          gap between law and society. We focus on educating individuals about
          their legal rights while also encouraging ethical responsibilities.
          This dual approach ensures that advocacy is not just about raising
          voices, but about creating meaningful and lasting change.
        </p>

        <p>
          We believe that awareness leads to empowerment. When individuals are
          informed, they are better equipped to handle challenges, seek justice,
          and contribute positively to society. Our goal is to create a network
          of aware and responsible citizens who can uphold justice and promote
          harmony.
        </p>

        <p>
          By becoming a part of ICSAJ’s advocacy initiatives, you join a
          movement dedicated to justice, integrity, and lawful action. Together,
          we can ensure that rights are protected, voices are heard, and justice
          is accessible to all.
        </p>

        <div className="text-center mt-4">
          <button
            className="btn btn-danger px-4 py-2"
            onClick={() => navigate("/memberform")}
          >
            Join Member
          </button>
        </div>
      </div>
    </PageLayout>
  );
}
